export var bankInfoAdapter = function() {
    var publicMethods = {};

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    publicMethods.getSAPPayloadFromAtlasPayload = function(atlasPayload, action) {
        return {
            'bankAccounts': [{
                'accountHolder': atlasPayload.accountHolder,
                'accountPurpose': 'DIRECT_DEPOSIT',
                'accountNumber': atlasPayload.accountNumber,
                'routingNumber': atlasPayload.routingNumber,
                'controlKey': atlasPayload.controlKey,
                'acceptedDirectDepositPolicy': true,
                'country': atlasPayload.countryCode,
                'IBAN': atlasPayload.IBAN,
                'accountType': atlasPayload.accountType === 'S' ? 'SAVINGS' : 'CHECKING',
                'action': action === 'UPDATE' ? 'UPDATE' : 'ADD'
            }]
        };
    };

    publicMethods.getAtlasResponseFromSAPResponse = function(SAPResponse) {
        var atlasResponse = {
            status: SAPResponse.status,
            data: {
                bank: {
                    branches: []
                }
            },
            bankAccounts: {}
        };

        atlasResponse.data.bank.branches.push({});

        if (SAPResponse.status == 200) {
            if (SAPResponse.data &&
                SAPResponse.data.account &&
                SAPResponse.data.account.bankAccounts &&
                SAPResponse.data.account.bankAccounts.length > 0) {
                atlasResponse.data.accountNumber = SAPResponse.data.account.id;
                atlasResponse.data.registeredName = SAPResponse.data.account.names.local;

                atlasResponse.data.accountType = SAPResponse.data.account.bankAccounts[0].accountType
                    === 'SAVINGS' ? 'S' : 'C';
                atlasResponse.data.routingNumber = SAPResponse.data.account.bankAccounts[0].routingNumber;

                atlasResponse.data.bank.number = SAPResponse.data.account.bankAccounts[0].accountNumber;
                atlasResponse.data.bank.name = SAPResponse.data.account.bankAccounts[0].bankName;
                atlasResponse.data.bank.branches[0].number = '';

                atlasResponse.bankAccounts.accountHolder = SAPResponse.data.account.bankAccounts[0].accountHolder;
                atlasResponse.bankAccounts.accountPurpose = SAPResponse.data.account.bankAccounts[0].accountPurpose;
                atlasResponse.bankAccounts.accountNumber = SAPResponse.data.account.bankAccounts[0].accountNumber;
                atlasResponse.bankAccounts.routingNumber = SAPResponse.data.account.bankAccounts[0].routingNumber;
                atlasResponse.bankAccounts.acceptedDirectDepositPolicy = SAPResponse.data.account
                    .bankAccounts[0].acceptedDirectDepositPolicy;
                atlasResponse.bankAccounts.countryCode = SAPResponse.data.account.bankAccounts[0].country;
                atlasResponse.bankAccounts.IBAN = SAPResponse.data.account.bankAccounts[0].IBAN;
                atlasResponse.bankAccounts.accountType = SAPResponse.data.account.bankAccounts[0].accountType
                    === 'SAVINGS' ? 'S' : 'C';
                atlasResponse.bankAccounts.branchName = SAPResponse.data.account.bankAccounts[0].bankName;
            }
        }

        return atlasResponse;
    };

    return publicMethods;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/services/adapters/bank-info-adapter.js
// module id = 44
// module chunks = 0